import md5 from 'js-md5'
import moment from 'moment'
import { Message, MessageBox } from 'element-ui'
import service, { http } from './http'
import store from '@/public/store'
import Router from '@/layout/router'
import { time } from './filter'
import { ENV } from '../config'

moment.locale('zh-cn')

// 数据字典 tms_virtualPhone_source
const kyexkj = { source: '10', company: 'kye-xkj' }
const VIRTUAL_PHONE_SOURCES = {
  'www.kye-erp.com': kyexkj,
  'www.ky-liangjian.com': kyexkj,
  'www.erp-qh.com': { source: '70', company: 'kye-qh' },
  'i.szfre.cn': { source: '80', company: 'jijin' }
}
export const VIRTUAL_PHONE_SOURCE = VIRTUAL_PHONE_SOURCES[location.hostname] || kyexkj

/**
 * 添加字体图标样式
 * @param {string} url - 字体图标的 URL
 */
export const addIconfontLink = (url) => {
  if (url && !document.head.querySelector(`link[href="//iconfont.kye-erp.com/t/${url}"]`)) {
    let link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = `//iconfont.kye-erp.com/t/${url}`
    document.head.appendChild(link)
  }
}

/**
 * 获取 Vite 路由
 * @param {Object} context - 上下文对象
 * @param {string} ignore - 要忽略的路由
 * @returns {Array} - 路由数组
 */
export const getRoutesForVite = (context, ignore) => {
  const children = []
  Object.keys(context).forEach(key => {
    if (key !== ignore) {
      try {
        let module = context[key].default
        let arr = module
        if (arr && arr.length) {
          children.push(...arr)
        }
        // })
      } catch (e) {
        Message({ message: `请检查前端路由文件：${e.stack}`, type: 'error', duration: 5000 })
        console.error(e)
      }
    }
  })
  return children
}

/**
 * 获取路由
 * @param {Function} context - 上下文函数
 * @param {string} ignore - 要忽略的路由
 * @returns {Array} - 路由数组
 */
export const getRoutes = (context, ignore) => {
  const children = []
  context.keys().forEach(key => {
    if (key !== ignore) {
      try {
        let arr = context(key).default
        if (arr && arr.length) {
          children.push(...arr)
        }
      } catch (e) {
        Message({ message: `请检查前端路由文件：${e.stack}`, type: 'error', duration: 5000 })
        console.error(e)
      }
    }
  })
  return children
}

/**
 * 注册业务线的 store 模块
 * @param {Object} module - 对应的store模块
 * @param {string} name - 模块名称
 */
export const registerStoreModule = (module, name) => {
  let need = Object.values(module).some(v => Object.keys(v).length > 0)
  if (need) {
    store.registerModule(name, module)
  }
}
/**
 * 创建模块布局
 * @param {string} name - 模块名称
 * @param {Function} context - 上下文函数
 * @param {string} url - 字体图标 URL
 * @returns {Object} - 业务系统的 Vue 组件对象
 */
export const createModuleLayout = (name, context, url) => {
  return {
    name,
    render (h) {
      // 这里需要使用transition，否则多个路由渲染同一个组件时，路由守卫触发时机不正确
      // https://github.com/vuejs/vue-router/issues/750
      return (
        <transition css={false} name="fade" mode="out-in">
          <keep-alive include={this.cachedViews}>
            <router-view class={name} />
          </keep-alive>
        </transition>
      )
    },
    mounted () {
      context && context()
      addIconfontLink(url)
    },
    computed: {
      cachedViews () {
        return this.$store.state.tagsView.cachedViews
      }
    }
  }
}
/**
 * 获取翻页器默认pageSize大小，传入 pageSize可设置默认pageSize
 * @param {Object} vm - Vue实例（this）
 * @param {number} pageSize - 翻页器 pageSize，传入可设置
 * @returns {number} - 当前翻页器的 pageSize 大小
 */
export const localPageSize = (vm, pageSize) => {
  let size = pageSize || vm.$pagination.pageSize
  try {
    let json = localStorage.getItem('GLOBAL_PAGINATION')
    if (json) {
      const tag = vm.tag
      json = JSON.parse(json)
      if (json[tag]) {
        size = json[tag]
      }
    }
  } catch (e) {
  }
  return size
}
/**
 * 设置冻结属性
 * @param {Object} obj - 目标对象
 * @param {string} key - 属性名
 * @param {*} value - 属性值
 */
export const defineFreezeProperty = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    enumerable: false,
    configurable: false,
    writable: true,
    value
  })
}

/**
 * 检查值是否为空
 * @param {*} val - 要检查的值
 * @returns {boolean} - 如果值为空则返回 true，否则返回 false
 */
export const isEmpty = val => val === '' || val === null || val === undefined

/**
 * 生成随机数
 * @param {number} count - 返回的随机数的位数
 * @returns {string} - 随机数
 */
export const random = (count) => {
  let num = Date.now() + Math.floor(1000 * Math.random() + 1000)
  if (count) {
    return num.toString().substr(-count)
  }
  return num.toString()
}

/**
 * 过滤参数（加密字段、虚拟号字段过滤密文）
 * @param {Object} params - 要过滤的对象
 * @param {string} [filterStr='****'] - 过滤包含的字符串
 * @returns {Object} - 过滤后的对象
 */
export const filterParams = (params, filterStr = '****') => {
  let result = JSON.parse(JSON.stringify(params))
  let recursive = (obj) => {
    let keys = Object.getOwnPropertyNames(obj)
    if (keys[keys.length - 1] === 'length') {
      keys.pop()
    }
    keys.forEach(k => {
      if (obj[k] && typeof obj[k] === 'object') {
        recursive(obj[k])
        if (Object.getOwnPropertyNames(obj[k]).length === 0) {
          Reflect.deleteProperty(obj, k)
        }
      } else {
        if (
          (obj.hasOwnProperty(k + 'MaskSec')) ||
          (obj[k + 'Mask'] && String(obj[k]).indexOf(filterStr) > -1) ||
          (obj[k + 'Virtual'] && String(obj[k]).indexOf(filterStr) > -1)
        ) {
          Reflect.deleteProperty(obj, k)
        }
      }
    })
  }
  recursive(result)
  return result
}


/**
 * 将数字转换为大写金额（1111 -> 壹仟壹佰壹拾壹元整）
 * @param {number} n - 要转换的数字
 * @returns {string} - 大写金额
 */
export const digitUppercase = (n) => {
  const fraction = ['角', '分']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
  let head = n < 0 ? '欠' : ''
  n = Math.abs(n)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (var j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

/**
 * 通过虚拟号获取是否有缓存登录人手机
 * @returns {string} - 虚拟号码
 */
let getVirtualPhoneNumber = () => {
  let localStorageNumber = localStorage.virtualPhoneNumber || ''
  let virtualPhoneNumber = ''
  let interval = '__'
  let employeeNumber = window.__ERPUSER__ && window.__ERPUSER__.employeeNumber
  let numberArr = localStorageNumber.split(interval)
  if (localStorageNumber && numberArr[0] === employeeNumber) {
    virtualPhoneNumber = numberArr[1]
  } else {
    localStorage.removeItem('virtualPhoneNumber')
  }
  return virtualPhoneNumber
}
/**
 * 获取当前激活的菜单信息
 * @returns {Object} - 当前菜单信息
 */
export const getCurrentMenu = _ => {
  let menu = window.__ERPMODULE__ || {}
  return { menu, tag: menu.menuCode || '' }
}

/**
 * 获取虚拟号码的额外参数
 * @param {Object} r - 请求参数
 * @param {Object} s - 请求参数
 * @param {Object} [source=VIRTUAL_PHONE_SOURCE] - 虚拟号码来源
 * @returns {Object} - 额外参数
 */
export const getVirtualPhoneExtraParams = (r, s, source = VIRTUAL_PHONE_SOURCE) => {
  let user = window.__ERPUSER__ || {}
  let { menu } = getCurrentMenu()
  return {
    business: menu.subSystem || '',
    remark1: menu.$ptitle,
    remark2: menu.$title,
    proposerId: user.id,
    proposer: user.name,
    position: user.duty,
    departmentId: user.departmentId,
    department: user.departmentInfo ? user.departmentInfo.departmentRoute : user.department,
    ...source
  }
}

/**
 * 获取当前路由的 title
 * @param {Object} vm - Vue 实例（this）
 * @returns {string} - 页面标题
 */
export const getModalPageName = (vm) => {
  return vm.$route.meta.title || ''
}

// 2022-10-28 重置document.activeElement
/**
 * 重置 document.activeElement
 * 在调用 MessageBox 前执行此方法，可修复提示框关闭后，页面会抖一下的问题
 */
const resetActiveElement = () => {
  let tmpEl = document.createElement('input')
  // 创建一个“页面不可见”但可以被focus的元素，变相改变activeElement的指向
  tmpEl.style = 'position: fixed; z-index: 1; top: 0; left: 0; width: 1px; height: 1px; opacity: 0; overflow: hidden;'
  document.body.appendChild(tmpEl)
  tmpEl.focus()
  setTimeout(function() {
    tmpEl.parentNode.removeChild(tmpEl)
  }, 80)
}

/**
 * 解密监控字段、虚拟号码
 * @param {Object} params - 请求参数
 * @param {string} type - 解密类型'mask'|| 'virtual'
 * @returns {Promise} - 解密后的数据
 */
export const decrypt = async (params, type) => {
  let data = null
  // 2022-10-28 MessageBox关闭后，控制是否需要重新聚焦回弹窗之前的元素(默认为true，兼容旧代码)
  let autoFocus = typeof params.autoFocus === 'boolean' ? params.autoFocus : true
  try {
    let moduleCode = params.moduleCode
    if (!moduleCode) {
      let { menu, tag } = getCurrentMenu()
      moduleCode = menu.component || tag
    }
    if (type === 'mask') {
      if (!autoFocus) resetActiveElement()
      await MessageBox.confirm(window.__ERPGLOABLECONFIG__.maskTips, '提示')
      data = await http('syslog.sensitiveFieldViewLog.save', {
        dataId: params.dataId,
        moduleCode,
        fieldName: params.fieldName,
        fieldContent: params.fieldContent,
        fieldNameStr: params.fieldNameStr || '',
        operateReason: params.operateReason || '',
        buttonName: params.buttonName || ''
      })
    } else if (type === 'virtual') {
      let virtualPhoneNumber = getVirtualPhoneNumber()
      const user = window.__ERPUSER__ || {}
      const mobile = user.companyMobile || user.privateMobile || ''
      // 座机号黑名单
      const virtualBlackList = (store.getters.lookUpOptions['sys_landline_block_list'] || []).map(v => v.value)
      let { value } = await MessageBox.prompt('将使用该号码进行拨打，如需使用其他号码请修改！<p style="color: #ff9300;font-size:12px;">为防止信息泄露，请使用【员工管理】内维护的号码进行拨打！</p>', '提示', {
        confirmButtonText: '获取号码',
        iconClass: ' ',
        inputValue: virtualPhoneNumber || mobile,
        // inputPattern: /(^1[3|4|5|6|7|8|9][0-9]\d{8}$)|(^(\d{3,4}-?\d{3,8})(-\d{1,4})?$)/,
        inputValidator: (val) => {
          const phoneRegex = /(^1[3|4|5|6|7|8|9][0-9]\d{8}$)/
          const landlineRegex = /^(\d{3,4}-?\d{3,8})(-\d{1,4})?$/
          const isPhone = phoneRegex.test(val)
          const isLandline = landlineRegex.test(val)
          const number = val.replace(/-/g, '')

          if (!isPhone && !isLandline) {
            return false
          }

          if (isLandline) {
            // 前三位不能全是 0
            if (/^000/.test(number)) {
              return false
            }

            // 后面部分不能全是 0 或全是 1
            const rest = number.slice(3)
            if (/^0+$/.test(rest) || /^1+$/.test(rest)) {
              return false
            }

            // 黑名单
            if (virtualBlackList.length) {
              return !virtualBlackList.some(v => v === val)
            }
          }

          return true
        },
        inputErrorMessage: '电话号码不正确',
        dangerouslyUseHTMLString: true,
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            const val = instance.inputValue
            if (/(^1[3|4|5|6|7|8|9][0-9]\d{8}$)/.test(val)) {
              const isMobile = await checkStaffMobile(val)
              if (!isMobile) {
                Message({ message: `为防止信息泄露，请使用【员工管理】内维护的号码进行拨打！`, type: 'warning' })
              } else {
                done()
              }
            } else {
              done()
            }
          } else {
            done()
          }
        }
      })
      let driverStatus = await checkDriverStatus(params.fieldContent)
      if (driverStatus && driverStatus.isDriver === 1 && (driverStatus.status === 2 || driverStatus.status === 1)) {
        if (!autoFocus) resetActiveElement()
        await MessageBox.confirm(`该司机正在${driverStatus.status === 2 ? '驾驶中' : '休息'}，请联系其上级领导 ${driverStatus.leader}。`, '提示', {
          confirmButtonText: '继续获取',
          iconClass: ' '
        })
      }
      let extra = getVirtualPhoneExtraParams()
      data = await http('basevirtual.virtualPhone.getVirtualNumber', {
        dataId: params.dataId,
        moduleCode,
        fieldName: params.fieldName,
        fieldContent: params.fieldContent,
        fieldNameStr: params.fieldNameStr || '',
        buttonName: params.buttonName || '',
        calloutPhone: value,
        ...extra
      }, '55041')
      // 产品需求，如果拨打成功虚拟号码，默认缓存到本地，下次直接获取，加入工号判断是否登录本人
      if (data) localStorage.virtualPhoneNumber = `${user.employeeNumber}__${value}`
    }
  } catch (e) {
    console.log(e)
  }
  return data
}

/**
 * 检查手机号是否是公司员工
 * @param {string} mobile - 手机号
 * @returns {Promise} - 检查结果
 */
const checkStaffMobile = mobile => http('hr.remoteEmployee.checkMobile', { mobile }, { cancel: true, appkey: 10124 })

/**
 * 检查司机是否在开车
 * @param {string} encryptMobile - 加密手机号
 * @returns {Promise} - 司机状态
 */
const checkDriverStatus = encryptMobile => {
  return new Promise(resolve => {
    let timer = setTimeout(_ => {
      resolve(null)
    }, 2000)
    http(
      'basevirtual.verifyAbout.getEmployeeCurrStatus',
      { encryptMobile },
      {
        axios: {
          headers: {
            appkey: '55041'
          }
        },
        cancel: true
      }
    ).then(res => {
      clearTimeout(timer)
      resolve(res)
    })
  })
}

/**
 * 文件流下载
 * @param {string} url - 下载的 URL
 * @param {Object} data - 请求数据
 * @param {string} fileName - 文件名
 */
export const exportFile = async (url, data, fileName) => {
  let isOpen = url.includes('.')
  let stream = await service({
    url: isOpen ? '' : url,
    method: 'post',
    headers: { method: isOpen ? url : '' },
    responseType: 'blob',
    data: data || {}
  })
  if (!fileName || fileName.startsWith('.')) {
    fileName = `${moment().format('YYYYMMDDHHmmssSSS')}${fileName || '.xls'}`
  }
  let blob = new Blob([stream])
  if ('download' in document.createElement('a')) {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL对象
    document.body.removeChild(elink)
  }
}

/**
 * 设置工单插件所需数据
 * @param {Object|null} data - 数据
 */
export const SET_ERPMODULEDATA = (data = null) => {
  if (typeof data === 'object') {
    data = JSON.parse(JSON.stringify(data))
  }
  window.__ERPMODULEDATA__ = data
}

/**
 * 创建水印样式
 * @param {Object} user - 用户信息
 * @param {number} alpha - 水印透明度
 */
export const createWatermarkStyle = (user, alpha) => {
  if (ENV === 'uat') {
    return
  }
  // let map = {
  //   1: 0.05,
  //   1.5: 0.04,
  //   2: 0.03,
  //   2.5: 0.02,
  //   3: 0.015,
  // }
  // alpha = map[alpha] * 1.5
  let map = {
    1: 0.1,
    1.5: 0.08,
    2: 0.075,
    2.5: 0.06,
    3: 0.04,
  }
  alpha = map[alpha]
  if (!user || !user.name) return
  let { employeeNumber } = user
  const nameText = employeeNumber ? `${employeeNumber}` : '跨越物流'
  const text = `${time(new Date())}`
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  let rotate = 24 * Math.PI / 180
  const font = 'normal 28px Microsoft YaHei'
  ctx.font = font
  const textWidth = ctx.measureText(text).width || 94
  let width = Math.floor(Math.cos(rotate) * textWidth)
  let height = Math.floor(Math.sin(rotate) * textWidth)
  const faultTolerant = 100
  canvas.width = width + faultTolerant * 6 + 360
  canvas.height = height + faultTolerant * 2 + 180
  canvas.style.width = canvas.width / 3 + 'px'
  canvas.style.height = canvas.height / 3 + 'px'
  ctx.fillStyle = `rgba(63,68,80,${alpha})`
  ctx.textBaseline = 'middle'
  ctx.rotate(-rotate)
  ctx.font = font
  ctx.fillText(nameText, -(faultTolerant / 3), height - 32 + (faultTolerant / 3))
  ctx.fillText(text, -(faultTolerant / 3), height + (faultTolerant / 3))

  ctx.save()
  ctx.translate(500, 350)
  ctx.fillText(nameText, -(faultTolerant / 3), height - 32 + (faultTolerant / 3))
  ctx.fillText(text, -(faultTolerant / 3), height + (faultTolerant / 3))
  ctx.restore()

  let encode = canvas.toDataURL('image/png')

  let div = document.querySelector('body #watermark2023')
  const backgroundSize = `${canvas.width / 2}px ${canvas.height / 2}px`
  const backgroundImageUrl = `url(${encode})`
  if (!div) {
    const div = document.createElement('div')
    const top = 50
    const left = 160
    div.id = 'watermark2023'
    div.style.pointerEvents = 'none'
    div.style.top = top + 'px'
    div.style.left = left + 'px'
    div.style.position = 'fixed'
    div.style.zIndex = '100000'
    div.style.width = document.documentElement.clientWidth - left + 'px'
    div.style.height = document.documentElement.clientHeight - top + 'px'
    div.style.background = backgroundImageUrl
    div.style.backgroundSize = backgroundSize
    // div.style.backgroundRepeat = 'no-repeat'
    document.body.appendChild(div)
  } else {
    div.style.background = backgroundImageUrl
    div.style.backgroundSize = backgroundSize
    // div.style.backgroundRepeat = 'no-repeat'
  }
}

/**
 * 生成 MD5 哈希
 * @param {string} token - 令牌
 * @param {string} timestamp - 时间戳
 * @param {Object} body - 请求体
 * @returns {string} - MD5 哈希值
 */
export const md5Http = (token, timestamp, body) => {
  return md5(md5(token).toUpperCase() + timestamp + JSON.stringify(body || {})).toUpperCase()
}

/**
 * 深度冻结对象
 * @param {Object} obj - 要冻结的对象
 * @returns {Object} - 冻结后的对象
 */
export const deepFreeze = obj => {
  let propNames = Object.getOwnPropertyNames(obj)
  for (let name of propNames) {
    let value = obj[name]
    obj[name] = value && typeof value === 'object' ? deepFreeze(value) : value
  }
  return Object.freeze(obj)
}

/**
 * 上报导出查询日志
 * @param {string} log - 中文查询条件
 * @param {number} total - 导出的数量
 * @param {string} buttonType - 导出按钮对应的文案（用于区分有多个按钮的情况）
 */
export const exportQueryLog = (log, total, buttonType) => {
  let { menu, tag } = getCurrentMenu()
  let data = {
    operateType: '导出',
    moduleCode: menu.component || tag,
    operateContent: `${buttonType || '导出'} (总条数: ${total || 0}) ${log || ''}`,
    operatorId: window.__ERPUSER__ ? window.__ERPUSER__.id : '1',
    dataId: menu.id || tag
  }
  http('syslog.userOperateLog.save', data, false)
}

/**
 * 根据路由获取菜单 ID
 * @param {Object} store - Vuex store
 * @param {Object} [route={}] - 路由对象
 * @returns {Object|null} - 菜单对象或 null
 */
export const getMenuIdByRoute = (store, route = {}) => {
  const menu = store && store.getters.menus[route.meta.tag]
  if (menu) {
    return menu
  }

  return getMenuIdByRouteMeta(route)
}

/**
 * 根据路由元信息获取菜单 ID
 * @param {Object} [route={}] - 路由对象
 * @returns {Object|null} - 菜单 ID 对象或 null
 */
export const getMenuIdByRouteMeta = (route = {}) => {
  if (route.meta && route.meta.menuId) {
    return { id: route.meta.menuId }
  }
  return null
}


/**
 * 上报日志
 * @param {Object} [opt={}] - 日志选项
 * @param {string} opt.app - 应用名称
 * @param {string} opt.menuId - 菜单 ID
 * @param {string} opt.logId - 日志 ID
 * @param {string} opt.log - 日志详情
 * @param {string} opt.logType - 日志类型
 * @param {string} opt.ext1 - 扩展字段
 * @param {string} opt.ext2 - 扩展字段
 * @param {string} opt.ext3 - 扩展字段
 */
export const logReport = (opt = {}) => {
  const user = window.__ERPUSER__ || {}
  const now = Date.now()
  const isSit = ENV === 'sit'

  // 环境不支持上报日志
  if (isSit) {
    return
  }

  if (!opt.menuId || !opt.logId || !opt.log) {
    throw new Error('[错误日志]:菜单id、日志编码、日志编码必填')
  }

  let data = {
    app: opt.app || 'ERP', // 应用名称
    module: opt.menuId, // 菜单id
    logId: opt.logId, // 日志id 建议：部门标识 + 编码，方便识别
    logDetail: opt.log, // 日志详情
    logType: opt.logType || 'error', // 日志类型
    createTime: now, // 创建时间
    navigator: navigator.userAgent, // 浏览器
    userId: user.id || '', // userId
    userName: user.name || '', // userName
    url: window.location.href, // url
    ext1: opt.ext1, // 扩展字段
    ext2: opt.ext2,
    ext3: opt.ext3
  }

  http('fmk.monitor.frontexception.log.report', data, { log: false, cancel: true, appkey: 55212 })
}

/**
 * 通过菜单 id 判断是否有模块权限
 * @param {string} menuId - 模块菜单 ID
 * @returns {Object|null} - 权限对象或 null
 */
export const getAuthByMenuId = (menuId) => {
  if (!menuId) return
  return Object.values(store.state.menus).find(i => i.id === menuId)
}

// 2022-12-06 日志上报类接口的专用域名，不走开放平台
export const collectApiMap = {
  uat: 'https://collect-uat.ky-express.com/json/collector',
  prd: 'https://collect.ky-express.com/json/collector'
}

/**
 * 关闭被打开的模块标签
 * @param {string} tag - 菜单模块 tag
 */
export const closeVisitedModule = (tag) => {
  try {
    const routeTag = tag || Router.currentRoute.meta.tag
    const tagsViewList = store.state.tagsView.visitedViews
    const tagView = tagsViewList.find(x => x.tag === routeTag)
    if (tagView) {
      store.dispatch('delVisitedViews', tagView)
    }
  } catch (error) {
    console.error('ERP-ERROR: closeVisitedModule', error)
  }
}

/**
 * 关闭当前页面下的所有弹窗
 * 没有遮罩层的弹窗不关闭
 */
export const closeRouteDialog = () => {
  try {
    const dom = document.querySelectorAll('.el-dialog__wrapper:not([style*="display: none"], [autoclose="off"])')
    if (dom && dom.length >= 1) {
      let arr = Array.from(dom)
      arr.forEach(item => {
        const dialogInstance = item.__vue__
        const dialogParent = dialogInstance.$parent
        // 不显示遮罩的弹窗不关闭
        if (dialogParent.modal) {
          dialogParent.hide()
        }
      })
    }
  } catch (error) {
    console.error('ERP-ERROR: closeRouteDialog', error)
  }
}


/**
 * 获取当前 DOM 的 XPath
 * @param {Element} element - DOM 元素
 * @returns {string} - XPath 字符串
 */
export const getXPath = (element) => {
  if (element && element.id) {
      return 'id("' + element.id + '")'
  } else if (element === document.body) {
      return element.tagName.toLowerCase()
  }

  let ix = 0
  const siblings = element && element.parentNode && element.parentNode.childNodes
  if (siblings) {
    for (let i = 0; i < siblings.length; i++) {
      const sibling = siblings[i]
      if (sibling === element) {
        return getXPath(element.parentNode) + '/' + element.tagName.toLowerCase() + '[' + (ix + 1) + ']'
      }
      if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
        ix++
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/common.js